import Vue from 'vue'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'

import httpSign from '../tools/httpSign'
import deviceInfoLib from '../tools/deviceInfo'
import $ from 'jquery'
import store from '../store'
import axios from 'axios'
import chanTools from '../tools/channel'
import locationHelper from '../tools/locationHelper'
import router from '../router'

let toast = function (text) {
Vue.$vux.toast.show({
width: 'auto',
type: 'text',
time: 2000,
position: 'middle',
text
})
}

let alert = function (text) {
Vue.$vux.alert.show({
title: '提示',
content: text
})
}

Vue.use(AjaxPlugin)


const Instance = axios.create({
baseURL: process.env.BASE_URL,
timeout: 1000 * 10,
headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
transformRequest: [function (data) {
if (data === undefined) {
return data
}
return $.param(data)
}]
})


Instance.interceptors.request.use(config => {
if (config.method === 'post') {
if (config.url.search(/putZADDPostData/) !== -1) {
config.timeout = 1000 * 30
}
let deviceInfo = deviceInfoLib.fetchDeviceInfo()
deviceInfo = JSON.parse(deviceInfo)
if (typeof (config.data) !== 'object') {
config.data = {}
}
for (let attr in deviceInfo) {
if (typeof (deviceInfo[attr]) === 'string') {
config.data[attr] = deviceInfo[attr]
}
}
if (config.data['chanNo'] === undefined) {
config.data['chanNo'] = chanTools.chanNo()
}
if (!chanTools.isApp()) {
config.data['ostype'] = chanTools.detectOS().osType
}
config.data['longitude'] = locationHelper.longitudeSyc()
config.data['latitude'] = locationHelper.latitudeSyc()
config.data['isFromApp'] = chanTools.isApp() ? '1' : '0'

config.data['platform'] = 'xyqb'
}

let sessionID = store.getters.sessionId

if (config.url.indexOf('http') === 0) {
if (config.params) {
config.params = httpSign.signForUrlOrFormData(config.params, true, sessionID)
} else if (config.data) {
config.data = httpSign.signForUrlOrFormData(config.data, false, sessionID)
} else {
if (config.method === 'GET') {
config.params = httpSign.signForUrlOrFormData(config.data, false, sessionID)
} else {
config.data = httpSign.signForUrlOrFormData(config.data, false, sessionID)
}
}
}
return config
}, (error) => {
toast('错误的传参')
return Promise.reject(error)
})


Instance.interceptors.response.use(res => {
return res.data
}, (error) => {
let errorData = ''
if (error.response.status === 404 || error.response.status === 502) {
router.push({'name': 'Error', query: {appText: true}}) 
return
}
if (error.response) {
errorData = error.response.data
if (errorData && errorData['errorCode'] === 99 ||
errorData && errorData['message'] === '会话超时') {
toast('该账号已在别处登录，如非本人操作请及时更换密码')

store.dispatch('logoutToLogin', true)
} else if (errorData && (
errorData['errorCode'] === 11226 ||
errorData['errorCode'] === 11231 ||
errorData['errorCode'] === 11232 ||
errorData['errorCode'] === 11234 ||
errorData['errorCode'] === 11233)) {
alert(errorData['errMsg'])

if (store.getters.isLogin) {
store.dispatch('logoutToLogin', true)
}
} else if (errorData && errorData['errorCode'] === 13001) {

} else if (errorData && errorData['errMsg'] !== undefined) {
toast(errorData['errMsg'])
} else {
toast('网络异常，请稍后重试')
}
} else {
router.push({'name': 'Error'}) 
toast('网络异常，请稍后重试')
}
return Promise.reject(errorData)
})

export default Instance




// WEBPACK FOOTER //
// ./src/api/resource.js